import * as React from "react";
import { Portal } from "../../components/atoms/Portal";
import { MenuItem } from "../../interface";

const DEFAULT_WIDTH = 180;

class Menu extends React.Component<{
    x: number;
    y: number;
    onClose?: () => void;
    onClick?: (item: MenuItem) => void;
    items: MenuItem[];
    menuWidth?: number;
    menuRef?: React.RefObject<HTMLDivElement>;
}> {
    public render(): React.ReactElement {
        const { items, onClose, onClick, x, y, menuWidth, menuRef } = this.props;
        return (
            <Portal>
                <div className="menu_blocker" onClick={onClose} />
                <div
                    ref={menuRef}
                    className="menu_bg"
                    style={{
                        right: x,
                        top: y,
                        width: menuWidth
                    }}
                >
                    {items.map((e: MenuItem, i: number) => {
                        if (typeof e !== "string" && !e.key) {
                            return (
                                <div className="menu_label" key={i} data-at_id={e["data-at_id"]}>
                                    {(() => {
                                        if (e.icon) {
                                            return <e.icon />;
                                        }
                                        return "";
                                    })()}
                                    {e.icon && <span className="spacer"> </span>}
                                    {e.name}
                                </div>
                            );
                        } else {
                            return (
                                <div
                                    className="menu_item"
                                    data-at_id={e["data-at_id"]}
                                    key={i}
                                    onClick={() => {
                                        if (onClick) onClick(e);
                                    }}
                                >
                                    {(() => {
                                        if (e.icon) {
                                            return <e.icon />;
                                        }
                                        return "";
                                    })()}
                                    {e.icon && <span className="spacer"> </span>}
                                    {typeof e === "string" ? e : e.name}
                                </div>
                            );
                        }
                    })}
                </div>
            </Portal>
        );
    }
}

export { Menu, DEFAULT_WIDTH };
